import React, { Component } from 'react';
import {
  contact,
  contact_mobile,
  FlexColumn,
  FlexRow,
  joinUsBtn,
  joinUsReady
} from '../partnerStyles';
import { NavLink } from 'react-router-dom';
import view from '../Enums';
import { Event } from '../Modules/LandingPageNew/Tracking/Track';
import * as GlobalActions from '../reducers/actions';
import { hmsSelfOnboardingEnabled } from '../config/countryConfig';

export default class ImageTextComponent extends Component {
  render() {
    let contactStyle, flexStyle, ordStyle;
    let imgInheritedStyle = {};
    if (this.props.imgInheritedStyle) {
      imgInheritedStyle = this.props.imgInheritedStyle;
    }
    if (this.props.viewSize === 'Desktop') {
      contactStyle = contact;
      flexStyle = {
        ...FlexRow,
        justifyContent: 'space-between',
        margin: '6% 15.3% 0 0'
      };
      ordStyle = {
        order: '2',
        width: '330px'
      };
    } else {
      contactStyle = contact_mobile;
      flexStyle = FlexColumn;
      ordStyle = {
        order: '1',
        width: '82%',
        margin: 'auto'
      };
    }

    return (
      <div style={this.props.componentStyle ? this.props.componentStyle : {}}>
        <div style={this.props.imgStyle ? this.props.imgStyle : {}}>
          {this.props.src && (
            <img
              style={{ ...this.props.imgInheritedStyle, objectFit: 'contain' }}
              width={this.props.width}
              height={this.props.height}
              src={this.props.src}
              alt={this.props.header ? this.props.header : this.props.content}
            />
          )}
        </div>
        <div style={this.props.textStyle ? this.props.textStyle : {}}>
          {this.props.header ? (
            <div style={this.props.headerStyle ? this.props.headerStyle : {}}>
              {this.props.header}
            </div>
          ) : (
            <null />
          )}
          {
            <div style={this.props.contentStyle ? this.props.contentStyle : {}}>
              {this.props.content}
            </div>
          }
          {this.props.linkContent ? (
            <div
              style={this.props.linkStyle ? this.props.linkStyle : {}}
              onClick={() =>
                this.props.link(this.props.fullContent, this.props.header)
              }
            >
              {this.props.linkContent}
            </div>
          ) : (
            <null />
          )}
          {this.props.join && this.props.joinButtonStyle && (
            <div
              style={{
                ...flexStyle,
                alignItems: this.props.viewMode == view.MOBILE ? 'center' : ''
              }}
            >
              {this.props.contactInfo && (
                <div style={contactStyle}>{this.props.contactInfo}</div>
              )}
              <div
                style={{
                  margin: '20px 0px'
                }}
              >
                {hmsSelfOnboardingEnabled() ? <button
                    className="hoverColor"
                    onClick={() => {
                      Event(
                          'Partner Page',
                          'Request a call on ready to get started section clicked',
                          this.props.locale,
                          ''
                      );
                      this.props.redirectToHms();
                    }}
                    style={{
                      ...this.props.joinButtonStyle
                    }}
                >
                  <span>{this.props.join}</span>
                </button>: <NavLink
                  exact
                  to="/form"
                  style={{ textDecoration: 'none', color: '#ffffff' }}
                  onClick={e => {
                    if (this.props.btnFunc) {
                      e.preventDefault();
                      this.props.btnFunc();
                    }
                  }}
                >
                  <button
                    className="hoverColor"
                    onClick={() => {
                      Event(
                        'Partner Page',
                        'Request a call on ready to get started section clicked',
                        this.props.locale,
                        ''
                      );
                    }}
                    style={{
                      ...this.props.joinButtonStyle
                    }}
                  >
                    <span>{this.props.join}</span>
                  </button>
                </NavLink>}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
